import React from 'react';
import { eventHasModifierKeys } from 'app/utils/env';

interface IProps extends React.AnchorHTMLAttributes<HTMLAnchorElement> {
  defaultOnClick?: (e: React.MouseEvent) => void;
  getRef?: (ref: HTMLAnchorElement) => void;
}

const doNothing = (e: React.MouseEvent) => e;

const BaseAnchor: React.FunctionComponent<IProps> = (props) => {
  const {
    getRef,
    defaultOnClick = doNothing,
    onClick = doNothing,
    ...rest
  } = props;

  // This click handler abstracts the behavior used in several Link like components.
  // The defaultOnClick handler is what a link like object wants to do if there are
  // no overriding handlers given. This behavior is considered less important than
  // a handler given to the component by onClick
  const handleClick = (event: React.MouseEvent<HTMLAnchorElement>) => {
    onClick(event);

    if (
      !event.defaultPrevented && // onClick prevented default
      event.button === 0 && // ignore everything but left clicks
      !props.target && // let browser handle "target=_blank" etc.
      !eventHasModifierKeys(event) // ignore clicks with modifier keys
    ) {
      defaultOnClick(event);
    }
  };

  return (
    // eslint-disable-next-line react/forbid-elements
    <a {...rest} onClick={handleClick} ref={getRef} />
  );
};

export default BaseAnchor;
